module.exports = __webpack_public_path__ + "img/card-reading.23286837.gif";